<template>
<div>
  <div class="title-h3 title-bar">구성 정보</div>
  <hr class="mr-b20">
  <el-row v-loading="isLoading" type="flex" justify="space-between" :gutter="20"  class="mr-t5">
    <el-col :span="24">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-row class="mr-b30">
            <div class="title-h4 title-bar">기본 정보</div>
            <div class="list form-list">
              <el-form ref="configForm" :model="formData" label-width="120px" :rules="configRules">
                <el-form-item label="인터페이스명">
                  <w-text-form :modifiable="modifiable" :target="formData" property="netinterfaceName">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="ipaddress" prop="ipaddress">
                  <w-text-form :modifiable="false" :target="formData" property="ipaddress">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="MAC 주소">
                  <w-text-form :modifiable="false" :target="formData" property="netinterfaceMacaddress">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="인터페이스 종류">
                  <w-text-form :modifiable="false" :target="formData" property="interfaceType">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="대역폭">
                  <w-number-form :modifiable="modifiable" :target="formData" property="netinterfaceSpeed" use-slot=true>
                    <span slot="data"> {{convertValueForInterfaceSpeed(formData.netinterfaceSpeed)}}</span>
                  </w-number-form>
                </el-form-item>
                <el-form-item label="대역폭 갱신">
                  <w-text-form :modifiable="false" :target="formData" property="updateFlag">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="인덱스">
                  <w-text-form :modifiable="false" :target="formData" property="netinterfaceIfindex">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="별칭">
                  <w-text-form :modifiable="false" :target="formData" property="netinterfaceAlias">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="Duplex">
                  <w-text-form :modifiable="false" :target="formData" property="netinterfaceDuplex">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="Oper 상태">
                  <w-text-form :modifiable="false" :target="formData" property="netinterfaceStatusOper" use-slot=true>
                    <span slot="data"> {{convertStatus(formData.netinterfaceStatusOper)}}</span>
                  </w-text-form>
                </el-form-item>
                <el-form-item label="Admin 상태">
                  <w-select-form :modifiable="false" :target="formData" :option-list="statusList" option-key="netinterfaceStatusAdmin" property="netinterfaceStatusAdmin" labelprop="label">
                  </w-select-form>
                </el-form-item>
                <el-form-item label="설명">
                  <w-text-form :modifiable="false" :target="formData" property="netinterfaceDevicename">
                  </w-text-form>
                </el-form-item>
              </el-form>
            </div>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row class="mr-b30">
            <div class="title-h4 title-bar">네트워크 장비 정보</div>
            <div class="list form-list">
              <el-form :model="formData" label-width="120px">
                <el-form-item label="장비명">
                  <w-text-form :modifiable="false" :target="formData" property="deviceObjName">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="ipaddress">
                  <w-text-form :modifiable="false" :target="formData" property="deviceIpaddress">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="장비 종류">
                  <w-text-form :modifiable="false" :target="formData" property="deviceObjtypeName">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="제조사">
                  <w-text-form :modifiable="false" :target="formData" property="deviceObjCompanyName">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="모델">
                  <w-text-form :modifiable="false" :target="formData" property="deviceObjProductId">
                  </w-text-form>
                </el-form-item>
              </el-form>
            </div>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row class="mr-b30">
            <div class="title-h4 title-bar">관리자/유지보수 정보</div>
            <div class="list form-list">
              <el-form :model="formData" label-width="120px">
                <el-form-item label="관리자(정)">
                  <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMajor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                    <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId">
                    </el-option>
                  </el-select>
                  <span v-else> {{getObjManagerName(formData.objManagerIdMajor)}} </span>
                </el-form-item>
                <el-form-item label="관리자(부)">
                  <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMinor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                    <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId">
                    </el-option>
                  </el-select>
                  <span v-else> {{getObjManagerName(formData.objManagerIdMinor)}} </span>
                </el-form-item>
                <el-form-item label="유지보수 업체">
                  <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceCompany">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="유지보수 담당자">
                  <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceManager">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="유지보수 연락처">
                  <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceTel">
                  </w-text-form>
                </el-form-item>
              </el-form>
            </div>
          </el-row>
          <el-row class="mr-b30">
            <div class="title-h4 title-bar">이벤트 제외 설정</div>
            <div class="list form-list">
              <el-form :model="formData" label-width="120px">
                <el-form-item label="이벤트 제외">
                  <w-check-form :modifiable="false" :target="formData" property="eventExceptFlag" tfType="Number">
                  </w-check-form>
                </el-form-item>
              </el-form>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEmpty, eq } from 'lodash';

// api
import niInfoAPI from '@/api/config/netinterface/netinterface-info';
import commonAPI from '@/api/config/common';
// for edit cmp
import WTextForm from '@/components/formeditor/TextFormEditor';
import WNumberForm from '@/components/formeditor/NumberFormEditor';
import WCheckForm from '@/components/formeditor/CheckFormEditor';
import wManagerTreeForm from '@/components/formeditor/MgrTreeSelectEditor';
import WSelectForm from '@/components/formeditor/SelectFormEditor';

import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValueForInterfaceSpeed, convertValuByUnit } from '@/utils/number';
import MsgUtil from '@/utils/message';

const statusList = [
  {
    label: 'UP',
    netinterfaceStatusAdmin: 1,
  },
  {
    label: 'DOWN',
    netinterfaceStatusAdmin: 2,
  },
];

export default {
  name: 'w-config-status',
  components: {
    niInfoAPI,
    WTextForm,
    WNumberForm,
    WCheckForm,
    wManagerTreeForm,
    WSelectForm,
  },
  props: {
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: true,
      false: false,
      managerList: [],
      objOriginData: {}, // Reject데이터
      formData: {}, // Form 바인딩 데이터
      statusList,
    };
  },
  computed: {
    ...mapGetters(['configRules', 'rejectConfigEditing', 'saveConfigEditing']),
    params() {
      return {
        objId: this.nodeParams.objId,
        managegroupId: this.nodeParams.parentObjId,
      };
    },
    modifiable() {
      return this.$store.state.config.isConfigEditing;
    },
  },
  watch: {
    params: {
      immediate: true,
      handler() {
        if (this.modifiable) {
          // 대상 변경 시 수정모드 종료
          this.$store.dispatch('setConfigEditing', false);
        }
        if (this.params.objId) {
          this.loadData();
        }
      },
    },
    rejectConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.formData = Object.assign({}, this.objOriginData);
          this.$store.dispatch('initRejectConfig');
        }
      },
    },
    saveConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.$refs.configForm.validate((valid) => {
            if (valid) {
              this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.SAVE))
                .then(() => {
                  const formData = this.formData;
                  const infoParams = Object.assign({}, formData);
                  const modifiedData = formData.modified;
                  const updateDate = {
                    objId: infoParams.objId,
                    netinterfaceId: infoParams.netinterfaceId,
                    netdeviceId: infoParams.deviceId,
                    deviceObjId: infoParams.deviceObjId,
                  };

                  if (modifiedData && Object.keys(modifiedData).length > 0) {
                    Object.keys(modifiedData).forEach((key) => {
                      updateDate[key] = formData[key];
                    });
                  } else {
                    updateDate.objManagerIdMajor = formData.objManagerIdMajor;
                    updateDate.objManagerIdMinor = formData.objManagerIdMinor;
                  }

                  const target = '구성 정보';
                  const action = MsgUtil.action.SAVE;
                  niInfoAPI
                    .updateNiConfigInfo(updateDate)
                    .then((result) => {
                      if (result.data.success) {
                        this.$message(MsgUtil.getResultMsgData(action, target, true));
                        this.$store.dispatch('endConfigEdit');
                        this.loadData();
                      } else {
                        this.$message(MsgUtil.getResultMsgData(action, target, false));
                      }
                    })
                    .catch(() => {
                      this.$message(MsgUtil.getResultMsgData(action, target, true));
                    });
                })
                .catch(() => {
                  this.$store.dispatch('setSaveConfigEditing', false);
                });
            } else {
              this.$store.dispatch('setSaveConfigEditing', false);
            }
          });
        }
      },
    },
  },
  methods: {
    convertValueForInterfaceSpeed,
    convertValuByUnit,
    getValueAfterCheckEmpty,
    thousandSep(value) {
      return isNil(value) ? EMPTY_TEXT : value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    convertStatus(value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      } else if (Number(value) === 1) {
        return 'UP';
      }
      return 'DOWN';
    },
    loadData() {
      this.isLoading = true;
      this.objOriginData = {};
      commonAPI.getMgrInfoList({}).then((res) => {
        this.managerList = res.data.data;
      });
      niInfoAPI.getNiConfigInfoBasic(this.params).then((result) => {
        if (result.data.success) {
          const data = result.data.data;

          if (eq(data.netinterfaceSpeedUpdateFlag, '1')) {
            data.updateFlag = '갱신 중';
          }
          Object.assign(this.objOriginData, data);
          this.formData = Object.assign({}, data);
          this.$emit('setConfigData', this.formData);
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    /**
     * managerName 조회
     * @param  {[type]} managerId [description]
     * @return {[type]}           [description]
     * @author jda
     */
    getObjManagerName(managerId) {
      if (isEmpty(managerId)) {
        return EMPTY_TEXT;
      }
      const mgrInfo = this.managerList.find((data) => data.managerId === managerId);
      return isEmpty(mgrInfo) ? EMPTY_TEXT : mgrInfo.managerName;
    },
  },
};
</script>

<style>
.form-list .el-form-item__label {
  text-align: left;
}

.form-header {
  padding-left: 10px;
  height: 25px;
  font-weight: bold;
  font-size: 14px;
  color: $chinagray;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/netinterface/configstatus/index.vue